export function requestHeaders() {
  const headers = {};
  const token = localStorage.getItem('token');
  if (token) headers.Authorization = `Bearer ${token}`;
  const garageId = localStorage.getItem('activeGarageId');
  if (garageId === 'all') {
    // "All branches" READ scope. A concrete branch (the last real one selected)
    // still goes as x-garage-id so writes / single-branch endpoints have a
    // valid target; x-garage-scope:all broadens READ queries to every branch
    // the caller is allowed (enforced server-side in getGarageFilter).
    headers['x-garage-scope'] = 'all';
    const fallback = localStorage.getItem('lastRealGarageId');
    if (fallback) headers['x-garage-id'] = fallback;
  } else if (garageId) {
    headers['x-garage-id'] = garageId;
  }
  return headers;
}

// The axios request-interceptor body (src/index.js registers this).
// Precedence: the session token and the all-branches scope always win; a
// caller's own x-garage-id is kept. A request pinned with
// utils/branchRequest withBranch() sets __singleBranch: it must NOT carry
// x-garage-scope, so the backend runs it as a single-branch call.
export function applyRequestHeaders(config) {
  const { 'x-garage-id': garageId, ...always } = requestHeaders();
  if (config.__singleBranch) delete always['x-garage-scope'];
  config.headers = config.headers || {};
  Object.assign(config.headers, always);
  if (config.__singleBranch) delete config.headers['x-garage-scope'];
  if (garageId && !config.headers['x-garage-id']) config.headers['x-garage-id'] = garageId;
  return config;
}
